var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SliderComponent',{attrs:{"slide-items":_vm.sliderImages}}),_c('HomeSectionOne'),_c('HomeSectionTwo'),_c('HomeSectionThree',{attrs:{"offers":_vm.offers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }